import { useCallback } from 'react'

import { useApiLazy } from '../../../hooks/useApiLazy'
import { UserDispensariesPutBody, UserMetadataDispensaries } from '../types'
import { useUserDispensaryClaims } from './useUserDispensaryClaims'

export type UseDispensaryUpdateUserForCode = [
  updateUserDispensary: (options: { practitionerCode: string }) => Promise<void>,
  updateUserDispensaryState: {
    data: UserMetadataDispensaries | null
    loading: boolean
    called: boolean
    error: Error | null
  },
]
export const useDispensaryUpdateUserForCode = ({
  refreshClaims = true,
}: {
  refreshClaims?: boolean
}): UseDispensaryUpdateUserForCode => {
  const { refreshClaims: doRefreshClaims } = useUserDispensaryClaims()

  const [doApiRequest, { loading, error, data, called }] = useApiLazy<
    UserMetadataDispensaries,
    UserDispensariesPutBody
  >()

  const updateUserDispensary = useCallback(
    async ({ practitionerCode }: { practitionerCode: string }): Promise<void> => {
      if (!practitionerCode) {
        return
      }
      await doApiRequest('/api/user/dispensaries', {
        loginRequired: true,
        method: 'PUT',
        body: {
          data: {
            practitionerCode,
          },
        },
      }).then((result) => {
        if (result._tag === 'Right' && refreshClaims) {
          return doRefreshClaims()
        }
        return undefined
      })
    },
    [doApiRequest, refreshClaims, doRefreshClaims],
  )

  return [updateUserDispensary, { loading, error, data, called }]
}
